<script>
import { toRef } from "vue";
import { useField } from "vee-validate";

export default {
  name: "FieldNumber",
  inject: [ 'store'],
  emits: ["evaluateValueResetter"],
  props: {
    field:{},
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // use `toRef` to create reactive references to `name` prop which is passed to `useField`
    // this is important because vee-validte needs to know if the field name changes
    // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
    const name = toRef(props, "name");
    const value = toRef(props, "value");

    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    const {
      value: inputValue,
      handleBlur,
      handleChange,
      meta,
    } = useField(name, undefined, {
      initialValue: value,
    });

    return {
      handleChange,
      handleBlur,
      inputValue,
      meta,
    };
  },
  mounted() {
    this.initialValue = this.store.calcModel[this.field.id]

  },
  computed:{
    sliderVal:{
      get(){
        return this.inputValue
      },
      set(val){
        const valInt = val.toString().replaceAll(',', '');
        const result = isNaN(valInt) ? 0 : valInt;
        this.sliderModel = result;
        this.store.calcModel[this.field.id] = result;
        this.inputValue = result;
      }
    },
    sliderModel:{
      get(){
        const val = this.inputValue
          || this.store.calcModel[this.field.id] 
          || this.store.resetterCache[this.field.id+"_min"]
          || 0;
        return val.toString().replaceAll(',', '');
      },
      set(val){
        const result = val.toString().replaceAll(',', '');
        this.inputValue = result;
        this.store.calcModel[this.field.id] = result;
      }
    }
  },
  methods:{
    maxVal(field) {
      return this.store.resetterCache[field.id + "_max"]
        ? Number(this.store.resetterCache[field.id + "_max"])
        : (Number(field.max_value) || 0);
    },
    handleFocus(e) {
      const value = e.target.value;
      e.target.value = value.replaceAll(',','')
    },
    handleBlur(e) {
      const value = e.target.value;
      e.target.value = value?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.$emit("onEvaluateValueResetter", this.field);
    },
    onblur(e){
      e.target.value = this.inputValue.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    evaluateValueResetter(result){
      this.inputValue = result;
      this.$emit("evaluateValueResetter", this.field)
    }
  },
  updated(){
    if(this.inputValue === 0 && this.store.resetterCache[this.field.id+"_min"]){
      this.inputValue = this.store.resetterCache[this.field.id+"_min"] || 0
    }
    if(this.$refs.sliderval !== document.activeElement){
      this.$refs.sliderval.value = this.$refs.sliderval.value?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted(){
    setTimeout(()=>{
      const inval = this.$refs.sliderval.value;
      this.$refs.sliderval.value = inval.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }, 300)
  }
}
</script>

<template>
  <input
    type="input"
    v-model="sliderVal"
    :id="name"
    :name="name"
    ref="sliderval"
    :placeholder="placeholder"
    :min='store.resetterCache[this.field.id+"_min"]'
    :max='store.resetterCache[this.field.id+"_max"]'
    :required="this.field.allow_empty == 0 ? true : false"

    @focus="handleFocus"
    @blur="handleBlur"
  />
</template>